import React from 'react';
import Footer from './Footer';

type BasePageProps = {
    children: React.ReactNode;
}

const BasePage: React.FC<BasePageProps> = ({ children }) =>
        <div className="wrapper">
                {children}
                <Footer />
        </div>;

export default BasePage;
